import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconMailFilled, IconPhoneCircleFilled } from '@zillow/constellation-icons';

import ListCell from './ListCell';

export type ChooseMethodProps = {
  onContactMethodLookup: (method: 'phone' | 'email') => void;
};

const ChooseMethod = ({ onContactMethodLookup }: ChooseMethodProps) => {
  return (
    <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)' }}>
      <Box css={{ gridColumnStart: { base: '1', lg: '3' }, gridColumnEnd: { base: 'span 12', lg: 'span 8' } }}>
        <Text
          css={{
            display: 'block',
            textAlign: 'center',
            fontWeight: 600,
            marginTop: '400',
            marginBottom: '400',
          }}
        >
          You&apos;ll need access to the listing contact email or phone number for verification
        </Text>
        <ListCell
          icon={
            <Icon size="lg" css={{ color: 'icon.accent.blue.strong' }}>
              <IconPhoneCircleFilled />
            </Icon>
          }
          primaryText="Phone"
          secondaryText="Find listings using your contact phone number"
          ctaIcon={true}
          onHeaderClick={() => onContactMethodLookup('phone')}
        />
        <ListCell
          addBorderBottom={true}
          icon={
            <Icon size="lg" css={{ color: 'icon.accent.blue.strong' }}>
              <IconMailFilled />
            </Icon>
          }
          primaryText="Email"
          secondaryText="Find listings using your contact email"
          ctaIcon={true}
          onHeaderClick={() => onContactMethodLookup('email')}
        />
      </Box>
    </Box>
  );
};

export default ChooseMethod;
